// extracted by mini-css-extract-plugin
module.exports = {"editor":"json-editor__editor___24l3Y"};